import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ConfigTabsContext } from '../../contexts/ConfigTabsContext';

const TAB_PATHS = [
  { id: 'model', path: 'model' },
  { id: 'match-rules', label: 'Match Rules', path: 'match-rules' },
  { id: 'business-rules', label: 'Business Rules', path: 'business-rules' },
  { id: 'validation-rules', label: 'Validation Rules', path: 'validation-rules' },
  { id: 'cleansers', label: 'Cleansers', path: 'cleansers' },
  { id: 'reference-datasets', label: 'Reference Datasets', path: 'reference-datasets' },
];

const ConfigurationTabsLayout = ({ basePath, entityLabel }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabItems = useMemo(() => TAB_PATHS.map((item) => {
    if (item.id === 'model') {
      return { ...item, label: `${entityLabel} Model` };
    }
    return item;
  }), [entityLabel]);

  const activeTab = tabItems.find((item) => location.pathname.includes(`/${item.path}`))?.id || 'model';

  const onTabChange = useCallback((event, tabId) => {
    const tab = tabItems.find((item) => item.id === tabId);
    if (tab) {
      navigate(`${basePath}/${tab.path}`);
    }
  }, [basePath, navigate, tabItems]);

  const contextValue = useMemo(
    () => ({ tabItems, activeTab, onTabChange }),
    [tabItems, activeTab, onTabChange]
  );

  return (
    <ConfigTabsContext.Provider value={contextValue}>
      <Box sx={{ width: '100%' }}>
        <Outlet />
      </Box>
    </ConfigTabsContext.Provider>
  );
};

ConfigurationTabsLayout.propTypes = {
  basePath: PropTypes.string.isRequired,
  entityLabel: PropTypes.string.isRequired,
};

export default ConfigurationTabsLayout;
